"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var bodyStylesList_1 = __importDefault(require("./bodyStylesList"));
var BodyStyleTile_1 = __importDefault(require("./BodyStyleTile"));
var SearchBarContext_1 = require("../../../SearchBarContext");
var DefaultSuggestions_styles_1 = require("../DefaultSuggestions.styles");
function calculateCardWidth(containerWidth) {
    // Divide the container width minus 16px left padding by 3.5 (3 cards fully visible + 50% of the fourth one)
    return (containerWidth - 16) / 3.5;
}
function DefaultBodyStyles(_a) {
    var _b;
    var inModal = _a.inModal, handleDefaultSuggestionClicked = _a.handleDefaultSuggestionClicked;
    var wrapperRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(6), gridCols = _c[0], setGridCols = _c[1];
    var wrapperWidth = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
    var showViewAll = (0, SearchBarContext_1.useWillNavigateToSearch)();
    var _d = (0, react_1.useState)(100), cardWidth = _d[0], setCardWidth = _d[1];
    (0, react_1.useEffect)(function () {
        if (wrapperWidth) {
            switch (true) {
                case wrapperWidth <= 830:
                    setGridCols(6);
                    break;
                default:
                    return setGridCols(Math.floor(wrapperWidth / 138));
            }
            if (inModal)
                setCardWidth(calculateCardWidth(wrapperWidth));
        }
    }, [inModal, wrapperWidth]);
    var bodyStylesToShow = (0, react_1.useMemo)(function () {
        return showViewAll
            ? bodyStylesList_1.default
            : bodyStylesList_1.default.filter(function (bodyStyle) { return bodyStyle.text !== 'View all'; });
    }, [showViewAll]);
    return (react_1.default.createElement(DefaultSuggestions_styles_1.SuggestionSectionContainer, null,
        react_1.default.createElement(DefaultSuggestions_styles_1.SectionTitle, { className: inModal ? 'pl-16' : '' }, "Vehicle Styles"),
        react_1.default.createElement("div", { ref: wrapperRef, className: (0, classnames_1.default)('w-full gap-8', inModal ? "flex ".concat(DefaultSuggestions_styles_1.modalStyles) : 'grid'), style: {
                gridTemplateColumns: inModal
                    ? undefined
                    : "repeat(".concat(gridCols, ", minmax(0,1fr))")
            } }, bodyStylesToShow.map(function (bodyStyle) { return (react_1.default.createElement(BodyStyleTile_1.default, { key: bodyStyle.text, bodyStyle: bodyStyle, handleDefaultSuggestionClicked: handleDefaultSuggestionClicked, isViewAllTile: bodyStyle.text === 'View all', width: cardWidth })); }))));
}
exports.default = DefaultBodyStyles;
//# sourceMappingURL=DefaultBodyStyles.js.map